module.exports = __webpack_public_path__ + "static/img/10.f58098b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-th/10.jpg
// module id = syul
// module chunks = 1